<template>
  <div class="card-content">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="block">
            <b-checkbox
              v-for="answer in question.answers"
              :key="answer.id"
              v-model="selectedAnswers"
              :native-value="answer.text"
              size="is-small"
              >{{ answer.text }}</b-checkbox
            >
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-button
            @click="export2Csv"
            type="is-info"
            icon-right="cloud-download-alt"
            size="is-small"
            :disabled="isLoading"
            >Exportar Lista</b-button
          >
        </div>
      </div>
    </div>
    <b-table
      :data="getUsers"
      :paginated="true"
      :pagination-simple="true"
      :per-page="perPage"
      striped
      bordered
      :loading="isLoading"
    >
      <template slot-scope="props">
        <b-table-column
          :field="field.value"
          :label="field.text"
          v-for="(field, index) in getHeaders"
          :key="index"
          sortable
        >
          {{
            field.type.toLowerCase() == "date"
              ? formatDate(props.row[field.value])
              : props.row[field.value]
          }}
        </b-table-column>
      </template>

      <template slot="empty">
        <span>Sem pessoas para exibir</span>
      </template>

      <template slot="footer">
        <div class="level" style="padding-bottom: 0">
          <div class="level-left"></div>
          <div class="left-center"></div>
          <div class="level-right">
            <b-select v-model="perPage" size="is-small">
              <option value="10">10 por página</option>
              <option value="25">25 por página</option>
              <option value="50">50 por página</option>
              <option value="100">100 por página</option>
            </b-select>
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import Webservices from "@/Webservices";

var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;
var moment = require("moment");

const ws = new Webservices();

export default {
  name: "UserQuestion",
  props: { question: Object },
  data() {
    return {
      perPage: 10,
      selectedAnswers: [],
      isLoading: false,
      headers: [],
      users: [],
      fields: []
    };
  },
  mounted() {
    ws.setToken(this.getToken);
    this.selectedAnswers = this.question.answers.map(el => el.text);

    ws.getClientFields(this.getID).then(response => {
      this.isLoading = true;

      this.fields = response.data.fields.filter(el => el.is_active);

      this.fields.push({ type: "string", name: "mac", label: "MAC" });

      this.fields.push({ type: "string", name: "resposta", label: "Resposta" });

      var deniedFields = this.fields.filter(
        el => el.name == "cpf" || el.type == "password"
      );

      deniedFields.forEach(el => {
        this.fields.splice(this.fields.indexOf(el), 1);
      });

      if (!!this.question) {
        ws.getUsersByQuestion(this.question.id, this.fields).then(response => {
          this.users = response.data.map(el => ({
            ...el,
            resposta: el.answers.find(x => x.question_id == this.question.id)
              .text
          }));
          this.isLoading = false;
        });
      }
    });
  },
  beforeUpdate() {},
  watch: {
    question(newValue) {
      this.selectedAnswers = this.question.answers.map(el => el.text);
      this.users = [];
      this.isLoading = true;
      ws.getUsersByQuestion(newValue.id, this.fields).then(response => {
        this.users = response.data.map(el => ({
          ...el,
          resposta: el.answers.find(x => x.question_id == this.question.id).text
        }));
        this.isLoading = false;
      });
    }
  },
  methods: {
    export2Csv() {
      var data = [];
      var macs = [];
      console.log(this.fields);
      var fields = this.fields
        .filter(el => el.type != "label")
        .map(el => el.name);
      var opts = { fields };

      const json2csvParser = new Json2csvParser(opts);
      const csv = json2csvParser.parse(this.getUsers);

      var blob = new Blob([csv], {
        type: "text/csv"
      });

      FileSaver.saveAs(blob, "respostas.csv");
    },

    formatDate(date_) {
      var date = date_;
      var saida = "";

      try {
        if (isNaN(new Date(date).getTime())) {
          date = date_
            .split("/")
            .reverse()
            .join("/");
        }

        saida = new Date(date).toLocaleDateString("pt-BR");
      } catch (exc) {
        saida = "Invalid Date";
      }

      return saida;
    }
  },
  computed: {
    ...mapGetters(["getID"]),
    getHeaders() {
      var saida = this.fields
        .filter(el => el.type != "label")
        .map(el => {
          return {
            text: el.label,
            value: el.name,
            type: el.type,
            sortable: false
          };
        });

      return saida;
    },
    getUsers() {
      return this.users.filter(el =>
        this.selectedAnswers.some(x => x == el.resposta)
      );
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/UserQuestion.vue